import { Button } from "@mui/material";
import { API } from "aws-amplify";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { DELETE_RECIPE } from "../constants/reducerEvents";

export default function Recipe({ recipe }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const deleteRecipe = () => {
    navigate("/");
    dispatch({ type: DELETE_RECIPE, payload: recipe });
  };
  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };
  return (
    <div style={{ position: "relative" }}>
      <div style={{ textAlign: "center", fontSize: "25px", fontWeight: "500" }}>
        {recipe.name}
      </div>
      <div style={{ textAlign: "center" }}>{recipe.totalTime}</div>
      <div style={{ position: "absolute", right: 0, top: 0, display: "flex" }}>
        <Button
          variant="contained"
          color="info"
          onClick={() => openInNewTab(recipe.url)}
        >
          Original Recipe
        </Button>
        <Button variant="contained" color="error" onClick={deleteRecipe}>
          Delete
        </Button>
      </div>
      <div style={{ width: "100%" }}>
        <div style={{ float: "right", width: "40%" }}>
          <img
            style={{ objectFit: "cover", width: "100%" }}
            src={recipe.image}
          />
        </div>
        <div style={{ float: "none", paddingLeft: "10px" }}>
          <div>Ingredients:</div>
          <ul>
            {recipe.recipeIngredients.map((ing, i) => (
              <li key={i}>{ing}</li>
            ))}
          </ul>
          <div>Instructions:</div>
          <ul>
            {recipe.recipeInstructions.map((ins, i) => (
              <li key={i}>{ins}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
